import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseFormViewer, CustomTitle, Form, FormCreatorService, FormSectionPageComponent, IFormOptions, VisorComponent } from 'lib-base';
import { FormularioService } from '../../../services/database/formulario.service';
import { MessageService } from 'primeng/api';
import { IGetFormularioWithRespuesta } from '../../../shared/interfaces/database/formulario';
import { HttpErrorResponse } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { FormViewerComponent } from '../../../components/form-builder-components/form-viewer/form-viewer.component';
import { StepsModule } from 'primeng/steps';
import { ButtonModule } from 'primeng/button';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-view-formulario-respuesta',
  standalone: true,
  imports: [
    CommonModule, ButtonModule, ReactiveFormsModule,
    VisorComponent, FormSectionPageComponent, TranslateModule,
    CustomTitle,
    StepsModule
  ],
  providers: [FormCreatorService],
  template: `
    <app-visor/>
    <div *ngIf="this.fc.Pages.length > 1" class="mb-2">
      <p-steps [model]="pageItems" [activeIndex]="fc.activeIndex"></p-steps>
    </div>

    <div class="form-panel-preview">
      <CustomTitle *ngIf="fc.Form.title" [title]="fc.Form.title" styleClass="font-principal font-20 title-blue border-round
                    ml-1 font-medium px-5 py-3 w-full bg-gray-200" />
      <div class="content formgrid p-fluid">
        <form #form="ngForm" [formGroup]="fc.FormGroup">
          <ng-container *ngIf="fc.activePage">
            <app-form-section-page [page]="fc.activePage" [pageIndex]="fc.activeIndex"
              [formGroup]="fc.getPageFormGroup(fc.activePage.name)" [isDesigner]="isDesigner">
            </app-form-section-page>
          </ng-container>
        </form>
      </div>
      <div class="footer">
        <div>
          <p-button *ngIf="!isFirstPage" [label]="'form.button.atras' | translate" (onClick)="prevPage()"
            icon="pi pi-angle-left"></p-button>
        </div>
        <div>
          <p-button *ngIf="!isLastPage" [label]="'form.button.siguiente' | translate" (onClick)="nextPage()"
            icon="pi pi-angle-right" iconPos="right"></p-button>
        </div>
      </div>
    </div>
  `,
  styleUrl: './../../../components/form-builder-components/form-viewer/form-viewer.component.scss'
})
export class ViewFormularioRespuestaComponent extends BaseFormViewer implements OnInit {

  @ViewChild(VisorComponent) visorDialog !: VisorComponent;

  private _tramRegistroId!: number;

  constructor(public override fc: FormCreatorService, private readonly _fs: FormularioService,
    private readonly _route: ActivatedRoute, private readonly _ms: MessageService) {
    super(fc)
    const options = {
      enableSubmit: false,
      isDesigner: false,
      viewAnswerMode: true
    } as IFormOptions;
    this.fc.setOptions(options);  

    this.fc.downloadFileEvent.subscribe(([radicado, fileId, fileName, saveFile]: [string, string, string, boolean]) => {
      this.onDownloadFile(radicado, fileId, fileName, saveFile);
    });
  }

  ngOnInit() {
    this._tramRegistroId = Number(this._route.snapshot.params['tramRegistroId']);
    this.getFormularioWithRespuesta();
  }

  getFormularioWithRespuesta() {
    if (!this._tramRegistroId) return;
    this._fs.getTramiteRespuesta(this._tramRegistroId).subscribe({
      next: (response: IGetFormularioWithRespuesta) => {
        let form = {
          id: response.formId,
          nombre: response.nombre,
          contenido: response.formulario
        } as Form;
        this.fc.loadForm(form, response.radicado);
        this.fc.Form.title = response.hojaDeVidaNombre;
        this.fc.loadRespuesta(response.respuesta);
      },
      error: (error: HttpErrorResponse) => {
        const parsedError = JSON.parse(error.error)
        this._ms.add({ severity: 'error', summary: parsedError.error, detail: parsedError.message });
      }
    });
  }

  onDownloadFile(radicado: string, fileId: string, fileName: string, saveFile: boolean) {
    this._fs.downloadFormFile(radicado, fileId).subscribe({
      next: (response: Blob) => {
        if (response.size > 0) {
          if (saveFile)
            saveAs(response, fileName);
          else
            this.visorDialog.showDialog(response);
        }
      }
    });
  }
}
